//==============================================================================
//==============================================================================
import * as React from 'react';
import classnames from 'classnames';

import * as Msdyn365 from '@msdyn365-commerce/core';

import { ISubstituteProductsViewProps, SubstituteProduct } from './substitute-products';
import { IHeadingData } from './substitute-products.props.autogenerated';

//==============================================================================
//==============================================================================
const BASE_CLASS = 'substitute-products';
const cls = (fragment: string) => `${BASE_CLASS}__${fragment}`;

//==============================================================================
//==============================================================================

//==========================================================
// Construct the header node
//==========================================================
function constructHeader(heading: IHeadingData): React.ReactNode {

    return heading.text && (
        <Msdyn365.Text
            className={cls('heading')}
            tag={heading.tag || 'h1'}
            text={heading.text}
        />
    );
}

//==========================================================
// Constructs the list of substitutes
//==========================================================
function constructEntries(list: SubstituteProduct[]): React.ReactNode {

    // Create 1 or more entries -- we checked for 0 entries externally
    return list.map(entry => (
        <div key={entry.id} className={cls('product')}>
            <a
                href={`/${entry.id}.p`}
                className={cls('link')}
                aria-label={entry.name}
            >{entry.name}</a>
            <div className={cls('price')}>{entry.price}</div>
        </div>
    ));
}

//==========================================================
// The main render function
//==========================================================
export default (props: ISubstituteProductsViewProps) => {

    // Ensure we have something to show
    if (!props.productList || !props.productList.length) {
        return null;
    }

    return (
        <div className={classnames(BASE_CLASS, {hidden: !props.showSubstitute})}>
            {props.config.heading && constructHeader(props.config.heading)}
            {constructEntries(props.productList)}
        </div>
    );
};
